export default __webpack_public_path__ + "static/media/WebsocketConnections_1.ce947f2e.svg";